<template>
<v-layout justify-center >
  <v-card flat width=250 class='my-4' >
    <v-card-text class='text-center text-xs-center' >
      <v-icon dark size='76' color='green' class='mt-4' >
        check_circle
      </v-icon>
      <h3 class='subheading text-xs-center mb-4' >
        {{ $t('title') }}
      </h3>

      <h3 class='overline text-center' >{{ $t('subtitles.nextsteps') }}:</h3>
      <v-btn
        @click='$emit("send", statement)'
        color='primary' outlined block class='mt-2' small  >
        {{ $t('buttons.send') }}
        <v-icon small class='ml-2' >send</v-icon>
      </v-btn>
      <v-btn
        :href='statement.url' target='_blank'
        outlined block class='mt-2' small outline >
        {{ $t('buttons.view') }}
        <v-icon small class='ml-2' >open_in_new</v-icon>
      </v-btn>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions >
      <v-spacer></v-spacer>
      <v-btn flat @click='$emit("close")' >
        {{ $t('buttons.done') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-layout>
</template>
<script>
export default {
  name: 'StatementSuccess',
  props: {
    statement: { type: Object, default: () => { return {} } }
  },
  i18n: {
    messages: {
      en: {
        title: 'Statement created',
        subtitles: {
          nextsteps: 'Next steps'
        },
        buttons: {
          send: 'Send',
          view: 'View',
          done: 'Done'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Success.vue?e6e452d0